// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object of properties containing the current block state.
   *
   * @object state
   */
  var state = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      ui.block = dom(".block.articles");
      ui.filters = dom(".block.filters");

      if (!ui.block) {
        return;
      }

      // Get the data from the CMS
      // TODO: When authoring increases, switch to loading more data via AJAX
      state.data = window.rgc_content || {};
      state.articles = state.data.articles || [];

      // Set the default state for the filters
      state.filters = {
        type: [],
        category: [],
      };

      // Handle the type filter
      ui.filterSelect = doms(".form-items .form-label-block");
      for (var index = 0; index < ui.filterSelect.length; index++) {
        ui.filterSelect[index].onclick = block.toggleFilterDropdown;
      }

      // Handle updating the filters
      ui.filterUpdate = doms(".form-filter-update");
      for (var index = 0; index < ui.filterUpdate.length; index++) {
        ui.filterUpdate[index].onclick = block.updateFilters;
      }

      // Handle selecting the filters
      ui.filterSelect = doms(".form-filter-select");
      for (var index = 0; index < ui.filterSelect.length; index++) {
        ui.filterSelect[index].onclick = block.selectFilters;
      }

      // Handle clearing the filters
      ui.filterClear = doms(".form-filter-clear");
      for (var index = 0; index < ui.filterClear.length; index++) {
        ui.filterClear[index].onclick = block.clearFilters;
      }

      // Handle clearing all of the filters
      ui.filterClearAll = doms(".form-filter-clearall");
      for (var index = 0; index < ui.filterClearAll.length; index++) {
        ui.filterClearAll[index].onclick = block.clearAllFilters;
      }

      // Handle on click of the load more button
      ui.loadMore = dom(".load .button");
      if (ui.loadMore) {
        ui.loadMore.onclick = block.loadMore;
      }

      // Allow clicking out of the drop-downs to close them
      document.body.onclick = function(event) {
        var dropdowns = doms(".form-item-select");
        for (var index = 0; index < dropdowns.length; index++) {
          dropdowns[index].classList.remove("active");
        }
      };

      // Ensure clicks on the drop-downs don't close them
      var dropdowns = doms(".form-filter-dropdown");
      for (var index = 0; index < dropdowns.length; index++) {
        dropdowns[index].onclick = function(event) {
          event.stopPropagation();
        };
      }

      // Watch checkbox click to update the labels
      var checkboxes = doms(".form-label-inline input");
      for (var index = 0; index < checkboxes.length; index++) {
        checkboxes[index].onchange = function(event) {
          block.updateFilterLabelMobile();
          block.updateFilterLabel(event.target.dataset.filter);
        };
      }

      // Open mobile filter overlay
      var selectMobile = dom(".form-item-select-mobile");
      if (selectMobile) {
        selectMobile.onclick = function(event) {
          event.preventDefault();
          ui.filters.classList.add("open");
          ui.filters.scrollTop = 0;
        };
      }

      // Close mobile filter overlay
      var filterToggle = dom(".filter-toggle");
      if (filterToggle) {
        filterToggle.onclick = function(event) {
          event.preventDefault();
          ui.filters.classList.remove("open");
        };
      }

    },

    /**
     * Method to handle toggling the filter drop down.
     *
     * @method block.toggleFilterDropdown
     */
    toggleFilterDropdown: function(event) {

      event.preventDefault();
      event.stopPropagation();

      var active = this.parentElement.classList.contains("active");
      var dropdowns = doms(".form-item-select");

      for (var index = 0; index < dropdowns.length; index++) {
        dropdowns[index].classList.remove("active");
      }

      if (active) {
        this.parentElement.classList.remove("active");
      } else {
        this.parentElement.classList.add("active");
      }

    },

    /**
     * Method to handle selecting all filter options.
     *
     * @method block.selectAllFilters
     */
    selectFilters: function(event) {

      event.preventDefault();

      block.toggleFilters.call(this, true);

    },

    /**
     * Method to handle clearing all filter options.
     *
     * @method block.clearFilters
     */
    clearFilters: function(event) {

      event.preventDefault();

      block.toggleFilters.call(this, false);

    },

    /**
     * Method to handle toggling filter options.
     *
     * @method block.toggleFilters
     */
    toggleFilters: function(enabled) {

      event.preventDefault();

      var items = null;
      var isMobile = this.classList.contains("form-filter-mobile");

      if (isMobile) {
        items = doms(".option-list input[type=checkbox]");
      } else {
        items = doms(".option-list input[type=checkbox]", this.parentElement);
      }

      for (var index = 0; index < items.length; index++) {
        items[index].checked = enabled;
      }

      block.updateFilterLabel("type");
      block.updateFilterLabel("category");
      block.updateFilterLabelMobile();

    },

    /**
     * Method to handle clearing all filter options.
     *
     * @method block.clearAllFilters
     */
    clearAllFilters: function(event) {

      event.preventDefault();

      var items = doms(".option-list input[type=checkbox]");

      for (var index = 0; index < items.length; index++) {
        items[index].checked = false;
      }

      state.filters.type = [];
      state.filters.category = [];
      block.setActiveArticles();
      block.setActiveTags();

      block.updateFilterLabel("type");
      block.updateFilterLabel("category");
      block.updateFilterLabelMobile();

    },

    /**
     * Method to handle updating the selected filters.
     *
     * @method block.updateFilters
     */
    updateFilters: function(event) {

      event.preventDefault();

      var isMobile = this.classList.contains("form-filter-mobile");

      block.setActiveFilters("type");
      block.setActiveFilters("category");

      block.setActiveTags();

      var dropdowns = doms(".form-item-select");
      for (var index = 0; index < dropdowns.length; index++) {
        dropdowns[index].classList.remove("active");
      }

      ui.filters.classList.remove("open");

    },

    /**
     * Method to handle setting the active filters.
     *
     * @method block.setActiveFilters
     */
    setActiveFilters: function(filter) {

      var parent = ".form-item-select-" + filter;
      var items = doms(parent + " .option-list input[type=checkbox]");

      state.filters[filter] = [];

      for (var index = 0; index < items.length; index++) {
        var item = items[index];
        if (item.checked) {
          state.filters[filter].push(item.value);
        }
      }

      block.setActiveArticles();

    },

    /**
     * Method to handle setting the active tags.
     *
     * @method block.setActiveTags
     */
    setActiveTags: function() {

      var wrapper = dom(".tag-wrapper");
      var tags = dom(".filter-tags", wrapper);
      var count = doms("button", tags).length;

      tags.innerHTML = "";

      wrapper.style.display = count === 0 ? "none" : "block";

      state.filters.type.forEach(function(filter) {
        tags.appendChild(block.createFilterTag(filter));
      });

      state.filters.category.forEach(function(filter) {
        tags.appendChild(block.createFilterTag(filter));
      });

    },

    /**
     * Method to handle creating a filter tag element.
     *
     * @method block.createFilterTag
     */
    createFilterTag: function(label) {

      var tag = document.createElement("li");

      var button = document.createElement("button");
      button.innerHTML = label;
      button.className = "button";

      tag.appendChild(button);

      return tag;

    },

    /**
     * Method to handle rendering the article push module.
     *
     * @method block.renderArticlePushModule
     */
    renderArticlePushModule: function(article, count) {

      var container = document.createElement("div");
      var id = "push-heading-" + state.data.id + "-" + count;

      container.className = "container" + (count >= 12 ? " article-hide" : "");
      container.dataset.type = article.type;

      if (article.image) {
        var link = document.createElement("a");
        link.className = "article-link";
        link.href = article.url;
        link.style.backgroundImage = "url('" + article.image + "')";
        // link.setAttribute("aria-describedby", id);
        link.setAttribute("aria-hidden", "true");
        link.setAttribute("tabindex", "-1");
        link.innerHTML = article.heading;
        if (article.type === "download") {
          link.setAttribute("download", "");
        } else if (article.type === "external") {
          link.target = "_blank";
          link.setAttribute("rel", "noopener");
        }
        container.appendChild(link);
      }

      var content = document.createElement("div");

      content.className = "content";

      if (article.duration) {
        var div = document.createElement("div");
        div.className = "subtitle-read subtitle-small";
        div.innerHTML = article.duration;
        content.appendChild(div);
      }

      if (article.heading) {
        var h3 = document.createElement("h3");
        h3.id = id;
        var link = document.createElement("a");
        link.href = article.url;
        link.innerHTML = article.heading;
        if (article.type === "download") {
          link.setAttribute("download", "");
        } else if (article.type === "external") {
          link.target = "_blank";
          link.setAttribute("rel", "noopener");
        }
        h3.appendChild(link);
        content.appendChild(h3);
      }

      if (article.teaser) {
        var div = document.createElement("div");
        div.innerHTML = "<p>" + article.teaser + "</p>";
        content.appendChild(div);
      }

      if (article.date) {
        var date = new Date(article.date);
        var div = document.createElement("div");
        div.className = "subtitle-small";
        div.innerHTML = date.toLocaleString("default", {
          month: "long", day: "numeric", year: "numeric",
        });
        content.appendChild(div);
      }

      container.appendChild(content);

      return container;

    },

    /**
     * Method to handle setting the active articles.
     *
     * @method block.setActiveArticles
     */
    setActiveArticles: function() {

      var hero = dom(".articles-hero");
      var secondary = dom(".articles-secondary");
      var count = 0;

      hero.innerHTML = "";
      if (secondary) {
        secondary.innerHTML = "";
      }

      state.articles.forEach(function(article) {
        var active = true;
        // Compare the article type
        if (state.filters.type.length) {
          if (state.filters.type.indexOf(article.publication.name) < 0) {
            active = false;
          }
        }
        // Compare the article category
        if (state.filters.category.length && article.category) {
          var found = false;
          article.category.forEach(function(category) {
            if (state.filters.category.indexOf(category.name) > -1) {
              found = true;
            }
          });
          if (!found) {
            active = false;
          }
        }
        if (active) {
          count += 1;
          if (count <= 2) {
            hero.appendChild(block.renderArticlePushModule(article, count));
          } else if (secondary) {
            secondary.appendChild(block.renderArticlePushModule(article, count));
          }
        }
      });

      ui.loadMore.style.display = count >= 12 ? "inline-block" : "none";

      block.setActiveTags();

    },

    /**
     * Method to handle on change of the filter checkbox options.
     *
     * @method block.updateFilterLabel
     */
    updateFilterLabel: function(filter) {

      var parent = ".form-item-select-" + filter;
      var label = dom(".form-select-" + filter + "-option");
      var items = doms(parent + " .option-list input[type=checkbox]");
      var count = 0;

      for (var index = 0; index < items.length; index++) {
        if (items[index].checked) {
          count += 1;
        }
      }

      label.innerHTML = count > 0
        ? label.dataset.selected.replace("{{count}}", count)
        : label.dataset.default;

    },

    /**
     * Method to handle on change of the filter checkbox options.
     *
     * @method block.updateFilterLabelMobile
     */
    updateFilterLabelMobile: function(filter) {

      var parent = ".form-item-select-mobile";
      var label = dom(".form-select-mobile-option");
      var items = doms(".option-list input[type=checkbox]");
      var count = 0;

      for (var index = 0; index < items.length; index++) {
        if (items[index].checked) {
          count += 1;
        }
      }

      label.innerHTML = count > 0
        ? label.dataset.selected.replace("{{count}}", count)
        : label.dataset.default;

    },

    /**
     * Method to handle loading more articles.
     *
     * @method block.loadMore
     */
    loadMore: function(event) {

      event.preventDefault();

      var hidden = doms(".article-hide");

      for (var index = 0; index < hidden.length; index++) {
        hidden[index].classList.remove("article-hide");
      }

      this.style.display = "none";

      if (hidden.length) {
        window.setTimeout(function() {
          hidden[0].querySelector("h3 a").focus();
        }, 10);
      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
